import React from 'react';

import { SVGComponentProps } from './svg.types';

const TrackedTimeClockSVG = ({
  fill = 'currentColor',
  size = '1em',
  stroke = 'currentColor',
  ...otherProps
}: SVGComponentProps) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <g clipPath="url(#clip0_3420_57602)">
        <path
          d="M7.00017 0.631104C5.73107 0.631104 4.49047 1.00743 3.43526 1.71251C2.38004 2.41758 1.5576 3.41973 1.07194 4.59222C0.586276 5.76471 0.459205 7.05489 0.706793 8.2996C0.954382 9.54431 1.56551 10.6877 2.4629 11.585C3.36028 12.4824 4.50362 13.0936 5.74834 13.3411C6.99305 13.5887 8.28323 13.4617 9.45572 12.976C10.6282 12.4903 11.6304 11.6679 12.3354 10.6127C13.0405 9.55746 13.4168 8.31687 13.4168 7.04777C13.4148 5.34658 12.7381 3.71564 11.5352 2.51272C10.3323 1.30979 8.70135 0.63311 7.00017 0.631104ZM9.16258 9.21019C9.05319 9.31955 8.90484 9.38098 8.75016 9.38098C8.59549 9.38098 8.44714 9.31955 8.33775 9.21019L6.58775 7.46019C6.47834 7.35082 6.41686 7.20247 6.41683 7.04777V3.54777C6.41683 3.39306 6.47829 3.24469 6.58769 3.13529C6.69708 3.0259 6.84546 2.96444 7.00017 2.96444C7.15487 2.96444 7.30325 3.0259 7.41264 3.13529C7.52204 3.24469 7.5835 3.39306 7.5835 3.54777V6.80627L9.16258 8.38535C9.27194 8.49475 9.33337 8.64309 9.33337 8.79777C9.33337 8.95245 9.27194 9.1008 9.16258 9.21019Z"
          fill="#878A92"
        />
      </g>
      <defs>
        <clipPath id="clip0_3420_57602">
          <rect width="14" height="14" fill="white" transform="translate(0 0.0478516)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TrackedTimeClockSVG;
